var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.768433 5.10703C0.768433 3.11007 2.38729 1.49121 4.38425 1.49121H11.6159C13.6129 1.49121 15.2317 3.11007 15.2317 5.10703V12.3387C15.2317 14.3356 13.6129 15.9545 11.6159 15.9545H4.38425C2.38729 15.9545 0.768433 14.3356 0.768433 12.3387V5.10703Z",
    fill: "#DFDFE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.10684C0 2.68552 1.96286 0.722656 4.38418 0.722656H11.6158C14.0371 0.722656 16 2.68552 16 5.10684V12.3385C16 14.7598 14.0371 16.7227 11.6158 16.7227H4.38418C1.96286 16.7227 0 14.7598 0 12.3385V5.10684ZM4.38418 2.25938C2.81157 2.25938 1.53672 3.53423 1.53672 5.10684V12.3385C1.53672 13.9111 2.81157 15.1859 4.38418 15.1859H11.6158C13.1884 15.1859 14.4633 13.9111 14.4633 12.3385V5.10684C14.4633 3.53423 13.1884 2.25938 11.6158 2.25938H4.38418Z",
    fill: "#2A2E33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.6793738ce12a21ac55e3c41ff052ac41.svg";
export { ForwardRef as ReactComponent };